import { connect } from 'react-redux';
import SettingsMenu from './settings-menu.component';

const mapStateToProps = ({ player }) => ({
  isEbookReaderOpen: player.isEbookReaderOpen,
});

export default connect(mapStateToProps)(SettingsMenu);
